var TimeCat = require('@antv/scale/lib/time-cat');

module.exports = TimeCat;